import React from "react";
import Lottie from "lottie-react";

// Import the JSON file (adjust the path based on where you saved it)
import loadingAnimation from "../assets/images/anim_lottiejson.json";

const LoadingSpinner = () => {
  return (
    <div style={{ width: "80px", height: "80px" }}>
      <Lottie animationData={loadingAnimation} loop={true} />
    </div>
  );
};

export default LoadingSpinner;